import { render, staticRenderFns } from "./ExtendedShowProduct.vue?vue&type=template&id=56d5cd77&scoped=true&"
import script from "./ExtendedShowProduct.vue?vue&type=script&lang=js&"
export * from "./ExtendedShowProduct.vue?vue&type=script&lang=js&"
import style0 from "./ExtendedShowProduct.vue?vue&type=style&index=0&lang=css&"
import style1 from "./ExtendedShowProduct.vue?vue&type=style&index=1&id=56d5cd77&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d5cd77",
  null
  
)

component.options.__file = "ExtendedShowProduct.vue"
export default component.exports